__turbopack_context__.v({
  "actionMenu": "kB8eLG_actionMenu",
  "avatarNotification": "kB8eLG_avatarNotification",
  "avatarWrapper": "kB8eLG_avatarWrapper",
  "avatar__initials": "kB8eLG_avatar__initials",
  "dropdownArrow": "kB8eLG_dropdownArrow",
  "isActive": "kB8eLG_isActive",
  "isOpen": "kB8eLG_isOpen",
  "navItem": "kB8eLG_navItem",
  "wrapper": "kB8eLG_wrapper",
});
